/**
 * Convierte un string de fecha (ej. "2023-02-19") a un objeto Date de forma segura cross-browser.
 */
export const safeDate = (dateString) => {
  if (!dateString) return new Date();
  return new Date(dateString.replace(/-/g, '/'));
};

/**
 * Calcula el precio actual estimado de un dominio basándose en:
 * 1. Incremento diario continuo (proporcional al tiempo transcurrido).
 * 2. Bono fijo del 30% del precio base por cada año completo cumplido.
 * 
 * @param {Object} domain Objeto del dominio con basePrice y listedDate.
 * @param {Date} [currentDate=new Date()] Fecha a comparar (por defecto ahora).
 * @returns {number} Precio calculado en la moneda base.
 */
export const calculateDomainCurrentPrice = (domain, currentDate = new Date()) => {
  if (!domain || typeof domain.basePrice !== 'number' || isNaN(domain.basePrice)) {
    return 0;
  }

  if (!domain.listedDate) {
    return domain.basePrice;
  }

  const listedDate = safeDate(domain.listedDate);
  const timeDiff = currentDate.getTime() - listedDate.getTime();
  
  // Años transcurridos con decimales (no negativo)
  const yearsSinceListing = Math.max(0, timeDiff / (1000 * 3600 * 24 * 365));
  const completedYears = Math.floor(yearsSinceListing);

  // Componente 1: Incremento diario continuo (proporcional al tiempo transcurrido)
  const dailyIncrease = domain.basePrice * 0.50 * yearsSinceListing;

  // Componente 2: Bono acumulativo del 50% por cada año completo transcurrido
  const annualBonus = domain.basePrice * 0.30 * completedYears;

  return domain.basePrice + dailyIncrease + annualBonus;
};
